import 'devextreme/dist/css/dx.light.css';
import { useEffect, useState } from "react";
import { Button, Space, Spin, notification, Tooltip, Table, } from 'antd';
import { EditFilled } from '@ant-design/icons'
import axios from 'axios';
import axiosConfig from '../../configs/axios.config';
import UserDetail from '../../components/userDetail/UserDetail';
import { useSelector } from 'react-redux';
import { AccessRolesSelector } from '../../store/reducers/permistion';
import { PAGE_SIZE, PAGE_SIZE_OPTIONS } from '../../configs/pageSize';
import { MODULES, ACTION } from '../../configs/namePermission';
import Utils from '../../utils';
import Search from 'antd/lib/transfer/search';
import { DataGrid } from 'devextreme-react';

function User() {
    const [pages, setPages] = useState([])
    const [total, setTotal] = useState([])
    const [paramsFilter, setParamsFilter] = useState({ amount: PAGE_SIZE, page: 1 })
    const [loading, setLoading] = useState(false)
    const AuthSelectors = useSelector(AccessRolesSelector)
    const [open, setOpen] = useState(false)
    const [type, setType] = useState('')
    const [detailData,setDetailData] = useState()

    const _getData = (page, pageSize, search = '') => {
        const response = axios.create(axiosConfig).get(`/api/pagingUsers?amount=${pageSize}&page=${page}&search=${search}`)
        setLoading(true)
        response
            .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || "Lỗi hệ thống",
                    })
                }
                const { list, total } = response.data.data
                setPages(list)
                setTotal(total)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
                setLoading(false)
                return notification.warning({
                    message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                })
            })
    }
    useEffect(() => {
        _getData(1, PAGE_SIZE)
    }, []);
    
    let timeOut = 500;
    const searchPaging = async (search = false) => {
        clearTimeout(timeOut)
        timeOut = setTimeout(() => {
            _getData(1, PAGE_SIZE,search.target.value);
        }, timeOut)
      }

    const updateData = (record) => {
        setOpen(true)
        setType('UPDATE')
        setDetailData(record)
    }
    

    const columns = [
    {
        title: 'STT',
        render: (text, record, index) => index + 1,
        align: 'center',
        key: 'index'
    },
    {
        title: 'Tên tài khoản',
        align: 'center',
        dataIndex: 'USER_CODE',
        render: (text) => text,
    },
    {
        title: 'Họ và Tên',
        align: 'center',
        dataIndex: 'U_NAME',
        render: (text) => text,
    },
    {
        title: 'Hành động',
        align: 'center',
        render: (text, record) => (
           
        <Space className="action">
            {
                Utils.checkPermistion(AuthSelectors, MODULES.PERMISSION, ACTION.UPDATE) ? 
                <Tooltip placement="top" title={'Chi tiết'}>
                    <Button onClick={() => { updateData(record) }}>
                        <EditFilled />
                    </Button>
                </Tooltip> : ''
            }
            
        </Space>
        )
    },
    ]
    
    return (
        <>
            <div className='search-custom' style={{display: 'flex', alignItems:'center', justifyContent: 'end', maxWidth: '200px', marginLeft: "auto"}}>
                <Search
                    placeholder="Tìm kiếm..."
                    allowClear
                    onChange={searchPaging}
                />
            </div>
            <Spin tip="Loading..." spinning={loading}>
                <div className='mt-3'>
                    <Table
                        dataSource={pages}
                        pagination={{
                            position: ['bottomCenter'],
                            current: paramsFilter.page,
                            pageSize: paramsFilter.amount,
                            pageSizeOptions: PAGE_SIZE_OPTIONS,
                            showQuickJumper: true,
                            onChange: (page, pageSize) => {
                                _getData(page,pageSize)
                              setParamsFilter({ ...paramsFilter, page: page, amount: pageSize })
                            },
                            total: total,
                        }}
                        columns={columns}
                        className="mt-3 table-custom"
                        bordered
                        scroll={{ x: 640 }}
                        rowKey={record => record.id}
                    ></Table>
                </div>
                <div >
                    <UserDetail 
                    open={open} 
                    type={type} 
                    detailData={detailData}
                    setOpen={setOpen} 
                    reloadPage={_getData}/>
                </div>
                
            </Spin>
            
        </>
    );
}

export default User;